// getters.js

export default {
    getTasksList(state){
        return state.tasksList.sort((a, b) => {
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return dateB - dateA; // Сортировка от новой к старой
        });
    }
};
